module.exports = __webpack_public_path__ + "static/media/reload.9ff5a7cb.svg";